{
    "Addusertitle": "Adicionar conta de utilizador da aplicação",
    "Modifyusertitle": "Modificar conta de utilizador da aplicação",
    "PermissionsTitle": "Permissões",
    "ExtensionTitle": "Extensão \/ Dispositivo",
    "ReportingTitle": "Comunicando",
    "AdministratorTitle": "Administrador",
    "RoleTitle": "Função",
    "SettingsTitle": "Definições",
    "ValidationWarning": "Corrija os erros antes de terminar",
    "ServerErrorTitle": "Erros de validação",
    "MonthlyBillingWarning": "AVISO: afeta a faturação mensal",
    "UnknownOrDeleted": "[Desconhecido ou Removido]",
    "AddUserLanguage_ButtonHelpLabel": "Ajuda?",
    "AddUserLanguage_ButtonSubmitLabel": "Gravar",
    "AddUserLanguage_ButtonCancelLabel": "Cancelar",
    "AddUserLanguage_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "AddUserLanguage_PromptConfirm": "sim",
    "AddUserLanguage_PromptCancel": "Cancelar",
    "AddUserLanguage_DetailsTitle": "Detalhes do usuario",
    "NAME": "AddUserLanguage",
    "APIKeys_Title": "Chaves de API"
}